// @flow
import {
    CLOSE_CONFIRMATION, OPEN_CONFIRMATION,
} from './constants';
import Proptypes from 'prop-types';

const INIT_STATE = {
    confirmModal: {
        open: false,
        message: undefined,
        payload: undefined,
        callBack: undefined
    }
};

type UIAction = { type: string, payload: {} | string };
type State = { 
    openDelete?: false, deleteItems?: [], deleteCallback?: Proptypes.func,
    openShare?: false, shareItems?: [], shareCallback?: Proptypes.func,
    +value?: boolean };

const UI = (state: State = INIT_STATE, action: UIAction) => {
    switch (action.type) {
        case OPEN_CONFIRMATION:
            return {...state,
                confirmModal: {
                    ...state.confirmModal,
                    ...action.payload,
                    open: true
                }};
        case CLOSE_CONFIRMATION:
            return {...state,
                confirmModal: {
                    ...state.confirmModal,
                    message: undefined,
                    payload: undefined,
                    callback: undefined,
                    open: false
                }};
        default:
            return {...state};
    }
};

export default UI;
